import {
  createSlice,
  handleFilters,
  replaceFilters,
  restoreFilterSnapshot,
  copyFilterSnapshot
} from "../helper";

const meetingRatingReportFiltersSlice = createSlice({
  name: "MeetingRatingReportFilters",
  initialState: {},
  reducers: {
    handleMeetingRatingReportFilters(prevState, action) {
      handleFilters(prevState, action);
    },
    replaceMeetingRatingReportFilters(prevState, action) {
      return replaceFilters(prevState, action);
    },
    restoreMeetingRatingReportFilterSnapshot(prevState, action) {
      restoreFilterSnapshot(prevState, action);
    },
    copyMeetingRatingReportFilterSnapshot(prevState, action) {
      copyFilterSnapshot(prevState, action);
    }
  }
});

export const filterActions = meetingRatingReportFiltersSlice.actions;

export default meetingRatingReportFiltersSlice;
